import { ISlide } from "./FullStackNetworkingSoftware.types";
import * as S from "./FullStackNetworkingSoftware.styles";
import React, { Fragment, useCallback, useMemo, useState } from "react";
import SiteManagerVideo from "assets/lfs/site-manager-video.mp4";
import SiteManagerPoster from "./assets/site-manager-video.jpg";
import { VideoModal } from "pages/LayoutComponents/VideoModal";
import { useHistory } from "react-router-dom";
import { SMALL_DEPLOYMENT_SOFTWARE_SLIDES } from "../../shared.config";
import { SoftwareSlide } from "./_components/SoftwareSlide";
import { SoftwareTabs } from "./_components/SoftwareTabs";

export const FullStackNetworkingSoftware = ({
  isInView,
}: Readonly<{ isInView?: boolean }>) => {
  const { hash } = window?.location;
  const history = useHistory();

  const [activeTab, setActiveTab] = useState<ISlide>(
    SMALL_DEPLOYMENT_SOFTWARE_SLIDES?.[0],
  );
  const [videoPlaybackTime, setVideoPlaybackTime] = useState<
    Record<number | string, number>
  >({});

  const slides = useMemo(() => {
    return SMALL_DEPLOYMENT_SOFTWARE_SLIDES;
  }, []);

  const onCanStartPlayback = (
    event: React.SyntheticEvent<HTMLVideoElement>,
  ) => {
    const totalPlaybackTime = event.currentTarget.duration;

    if (!totalPlaybackTime) {
      return;
    }

    setVideoPlaybackTime((prev) => ({
      ...prev,
      [activeTab.id]: totalPlaybackTime,
    }));
  };

  const switchToNextVideo = useCallback(() => {
    setActiveTab((prev) => {
      const nextIndex = prev.index + 1;
      const isLastIndex = nextIndex >= slides.length;
      const correctedIndex = isLastIndex ? 0 : nextIndex;

      return slides[correctedIndex];
    });
  }, [slides]);

  const updateTab = useCallback((tab: ISlide) => {
    setActiveTab(tab);
  }, []);

  return (
    <Fragment>
      <S.Wrapper>
        <S.StyledContainer size="desktop" noVerticalMargin>
          <SoftwareTabs
            slides={slides}
            activeTab={activeTab}
            videoPlaybackTime={videoPlaybackTime}
            onUpdateTab={updateTab}
            isInView={isInView}
          />
          <SoftwareSlide
            item={activeTab}
            isInView={isInView}
            onStartVideoPlayback={onCanStartPlayback}
            onVideoEnded={switchToNextVideo}
          />
        </S.StyledContainer>
      </S.Wrapper>

      <VideoModal
        src={{ hd: SiteManagerVideo }}
        poster={SiteManagerPoster}
        isOpen={hash.includes("site-manager-popup")}
        motif="light"
        onClose={() => {
          history.replace(window.location.pathname);
        }}
      />
    </Fragment>
  );
};
